import { DEFAULT_INITIAL_VALUES } from './Filters.constants'

export function getInitialValues() {
  return {
    ...DEFAULT_INITIAL_VALUES,
  }
}
